if (!customElements.get('scroll-reveal-steps')) {
  customElements.define(
    'scroll-reveal-steps',
    class ScrollRevealSteps extends HTMLElement {
      connectedCallback() {
        this.steps = Array.from(this.querySelectorAll('[data-scroll-reveal-step]'));
        this.mediaItems = Array.from(this.querySelectorAll('[data-scroll-reveal-image]'));

        if (this.steps.length === 0 || this.mediaItems.length === 0) return;
        if (!('IntersectionObserver' in window)) return;

        // Activate the first step immediately so the page doesn't start blank
        this.activate('0');

        this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
          root: null,
          rootMargin: '-40% 0px -40% 0px',
          threshold: 0,
        });

        this.steps.forEach((step) => this.observer.observe(step));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      onIntersect(entries) {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const index = entry.target.getAttribute('data-scroll-reveal-step');
          this.activate(index);
        });
      }

      activate(index) {
        // Swap image
        this.mediaItems.forEach((item) => {
          item.classList.toggle('is-active', item.getAttribute('data-scroll-reveal-image') === index);
        });

        // Mark active step for text reveal styling
        this.steps.forEach((step) => {
          step.classList.toggle('is-active', step.getAttribute('data-scroll-reveal-step') === index);
        });
      }
    }
  );
}
